<div class="table-body mt-2">
  <div class="table-body-head mb-3">
    <div>
      <label class="table-title">{{ "assigner.title_list" | translate }}</label>
    </div>
    <tui-hosted-dropdown
      tuiDropdownLimitWidth="auto"
      [content]="download_options"
      [(open)]="open"
    >
      <label class="table-title-filter">
        {{ "assigner.results_count" | translate }} ({{ totalCountDisplayed }})
      </label>
      <button
        tuiHostedDropdownHost
        class="export-button"
        [disabled]="isLoading || !showTable"
      >
        <img
          class="img-icon"
          src="../../../assets/icons/download-Icon.svg"
          alt=""
        />
        {{ "assigner.export_text" | translate }} (.csv, xls..)
      </button>
    </tui-hosted-dropdown>
  </div>
  <div class="table-body-options mb-3">
    <ng-select
      [items]="zones"
      bindLabel="zoneName"
      bindValue="zoneId"
      [multiple]="false"
      [(ngModel)]="selectedZoneId"
      class="custom_select"
      (ngModelChange)="onZoneChange($event)"
      [placeholder]="'assigner.zone_input' | translate"
      [dropdownPosition]="'bottom'"
      [disabled]="isLoading"
    >
    </ng-select>
  </div>
  <div class="table-container">
    <!-- Loader -->
    <div *ngIf="isLoading" class="table-loader">
      <tui-loader size="l" [showLoader]="true" [overlay]="true"></tui-loader>
    </div>

    <!-- Empty State - No data at all -->
    <div *ngIf="showEmptyState" class="empty-state">
      <div class="empty-state-icon">
        <!-- SVG... -->
      </div>
      <h3 class="empty-state-title">
        {{ "assigner.empty_state_title" | translate }}
      </h3>
      <p class="empty-state-description">
        {{ "assigner.empty_state_description" | translate }}
      </p>
    </div>

    <!-- No Results State - Data exists but filters return nothing -->
    <div *ngIf="showNoResultsState" class="empty-state">
      <div class="empty-state-icon no-results-icon">
        <!-- SVG... -->
      </div>
      <h3 class="empty-state-title">
        {{ "assigner.no_results_title" | translate }}
      </h3>
      <p class="empty-state-description">{{ emptyStateMessage }}</p>
    </div>

    <!-- Table - Only show when there's data -->
    <table
      *ngIf="showTable"
      tuiTable
      size="l"
      class="table-full-width"
      [columns]="columns"
    >
      <thead>
        <tr tuiThGroup class="table-header">
          <th
            class="th-style"
            *tuiHead="'date'"
            tuiTh
            (click)="setSortColumn('executionDateFormatted')"
            [sticky]="true"
          >
            {{ "assigner.date_excute_input_table" | translate }}
          </th>
          <th
            class="th-style"
            [sticky]="true"
            *tuiHead="'time'"
            tuiTh
            (click)="setSortColumn('hour')"
          >
            {{ "assigner.hour_input_table" | translate }}
          </th>
          <th
            [sticky]="true"
            *tuiHead="'executedBy'"
            tuiTh
            (click)="setSortColumn('executorId')"
          >
            {{ "assigner.executor_input_table" | translate }}
          </th>
          <th
            [sticky]="true"
            *tuiHead="'status'"
            tuiTh
            (click)="setSortColumn('status')"
          >
            {{ "assigner.status_input_table" | translate }}
          </th>
          <th
            [sticky]="true"
            *tuiHead="'zoneAssignment'"
            (click)="setSortColumn('zoneName')"
            tuiTh
          >
            {{ "assigner.zone_input_table" | translate }}
          </th>
          <th
            [sticky]="true"
            *tuiHead="'assignmentDate'"
            (click)="setSortColumn('assignmentDateFormatted')"
            tuiTh
          >
            {{ "assigner.date_assigned_input_table" | translate }}
          </th>
          <th [sticky]="true" *tuiHead="'actions'" [sorter]="null" tuiTh>
            {{ "assigner.actions_input_table" | translate }}
          </th>
        </tr>
      </thead>
      <tbody tuiTbody>
        <tr tuiTr *ngFor="let item of paginatedData">
          <td *tuiCell="'date'" tuiTd>
            <div [tuiCell]="size">
              <span tuiTitle>
                {{ item.executionDateFormatted }}
              </span>
            </div>
          </td>
          <td *tuiCell="'time'" tuiTd>
            <div [tuiCell]="size">
              <span tuiTitle>
                {{ item.hour }}
              </span>
            </div>
          </td>
          <td *tuiCell="'executedBy'" tuiTd>
            <div [tuiCell]="size">
              <tui-avatar
                [src]="item.executorName | tuiInitials"
                [style.background]="
                  item.executorName | tuiAutoColor
                "
              ></tui-avatar>
              <span tuiTitle>
                {{ item.executorName }}
              </span>
            </div>
          </td>

          <td *tuiCell="'status'" tuiTd>
            <div>
              <div *ngIf="item?.status == 'InProgress'">
                <tui-badge
                  status="success"
                  [value]="'assigner.status_in_progress' | translate"
                  class="custom_picking_up tui-space_right-2 tui-space_bottom-2"
                ></tui-badge>
              </div>
            </div>
            <div *ngIf="item?.status == 'Completed'">
              <tui-badge
                status="success"
                [value]="'assigner.status_completed' | translate"
                class="custom_finished tui-space_right-2 tui-space_bottom-2"
              ></tui-badge>
            </div>
            <div *ngIf="item?.status == 'Failed'">
              <tui-badge
                status="error"
                [value]="'assigner.status_failed' | translate"
                class="tui-space_right-2 tui-space_bottom-2"
              ></tui-badge>
            </div>
            <div *ngIf="item?.status == 'Applied'">
              <tui-badge
                status="info"
                [value]="'assigner.status_applied' | translate"
                class="tui-space_right-2 tui-space_bottom-2"
              ></tui-badge>
            </div>
            <div *ngIf="item?.status == 'Initialized'">
              <tui-badge
                status="warning"
                [value]="'assigner.status_initialized' | translate"
                class="tui-space_right-2 tui-space_bottom-2"
              ></tui-badge>
            </div>
            <div *ngIf="!item?.status">
              <tui-badge
                status="neutral"
                [value]="'assigner.status_no_status' | translate"
                class="tui-space_right-2 tui-space_bottom-2"
              ></tui-badge>
            </div>
          </td>

          <td *tuiCell="'zoneAssignment'" tuiTd>
            <div [tuiCell]="size">
              <span tuiTitle>
                {{ item.zoneName }}
              </span>
            </div>
          </td>
          <td *tuiCell="'assignmentDate'" tuiTd>
            <span tuiTitle>
              {{ item.assignmentDateFormatted }}
            </span>
          </td>
          <td *tuiCell="'actions'" tuiTd>
            <span class="seeAllIcon" tuiStatus>
              <button
                (click)="tryApplyAssignament(item)"
                [disabled]="item.status != 'Completed' || isLoading"
                appearance="primary-button"
                size="s"
                tuiButton
              >
                {{ "assigner.apply_text" | translate }}
              </button>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="showTable" class="table-footer mt-4">
    <div class="table-pagination" [class.pagination-disabled]="isLoading">
      <tui-pagination
        [index]="index"
        [length]="length"
        (indexChange)="!isLoading && goToPage($event)"
      ></tui-pagination>
    </div>
  </div>
</div>

<ng-template #download_options let-activeZone>
  <div class="download-menu">
    <label class="mb-2 export-title">{{
      "assigner.complement_export_text" | translate
    }}</label>

    <div class="d-flex mb-2 export-body-label">
      <tui-checkbox
        [(ngModel)]="isXlsxSelected"
        (ngModelChange)="updateExportCount()"
        class="tui-space_bottom-3"
        [disabled]="isLoading"
      ></tui-checkbox>
      <label [class.disabled-label]="isLoading">{{
        "assigner.export_xlsx_label" | translate
      }}</label>
    </div>

    <div class="d-flex mb-2 export-body-label">
      <tui-checkbox
        [(ngModel)]="isCsvSelected"
        (ngModelChange)="updateExportCount()"
        class="tui-space_bottom-3"
        [disabled]="isLoading"
      ></tui-checkbox>
      <label [class.disabled-label]="isLoading">{{
        "assigner.export_csv_label" | translate
      }}</label>
    </div>

    <button
      (click)="exportTo()"
      class="export-button-menu mb-2 mt-1"
      [disabled]="isLoading || exportCount === 0"
    >
      <img
        class="img-icon"
        src="../../../assets/icons/download-Icon.svg"
        alt=""
      />
      {{ "assigner.export_text" | translate }} ({{ exportCount }})
    </button>
  </div>
</ng-template>

<ng-template #warning_assigner_modal>
  <!-- Modal -->
  <div id="myModal" class="modal-content">
    <div class="modal-header-custom">
      <!-- SVG + title -->
      <div>{{ "assigner.modal_override_title" | translate }}</div>
    </div>
    <div class="modal-body-custom">
      <p class="modal-message">
        {{ "assigner.modal_override_message" | translate }}
        <span class="modal-highlight"> {{ toApplyAssignamentDate }} </span>.
      </p>
      <p class="modal-warning">
        {{ "assigner.modal_override_warning" | translate }}
      </p>
    </div>
    <div class="modal-footer-custom">
      <button
        (click)="closeModal()"
        class="cancel-over-write-button"
        [disabled]="isApplyingAssignment"
      >
        {{ "assigner.modal_back_button" | translate }}
      </button>
      <button
        (click)="applyAssignament(toApplyAssignamentId)"
        class="over-write-button"
        [disabled]="isApplyingAssignment"
      >
        <tui-loader
          *ngIf="isApplyingAssignment"
          size="s"
          [showLoader]="true"
          class="button-loader"
        ></tui-loader>
        <span *ngIf="!isApplyingAssignment">
          {{ "assigner.modal_override_button" | translate }}
        </span>
        <span *ngIf="isApplyingAssignment">
          {{ "assigner.modal_applying" | translate }}
        </span>
      </button>
    </div>
  </div>
</ng-template>
